module.exports = __webpack_public_path__ + "static/media/Entrepreneur.c2f465dd.png";